import { HttpClient } from '@angular/common/http';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { Geolocation } from '@capacitor/geolocation';
import { LoadingController, ModalController, NavController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { Device } from '@capacitor/device';
import { CommonModule } from '@angular/common';
import * as CryptoJS from 'crypto-js';

//import { waitForAsync } from '@angular/core/testing';
//import { Camera, CameraOptions } from '@ionic-native/camera/ngx';

import { SQLite, SQLiteObject } from '@ionic-native/sqlite/ngx';
import * as numeral from 'numeral';






import { consql } from './sqlite';
import { File } from '@ionic-native/file/ngx';
import { MenuComponent } from '../components/menu/menu.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { VerdocumentosPage } from '../pages/verdocumentos/verdocumentos.page';

 
@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {

  

  iv: any
  textenc: any
  //private proyecto="";
  private usuario="";
  private nombreusuario="";
  private tipousuario="";
  private plantaid="";
  private plantadescripcion="";
  public tipomenu="";
  public perfilusu="oscar david sandoval zzz";

  public titulodatasheet="";



  private keysec="";  
  public datainfo;
  

  
public imgcheck="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAlpJREFUOE+NVM9LVFEUviAiuBlGcMSFzloRBFEE8W/wbzBCbX48nWZiXpE2KY1EWWm0a9HG4GVFRDoziiuXLnrU5KJFz4IGChe2aCXB1zn33Tfv5wx+8M2b+94537vnnO9dgRaofqoi/zaP0SejiJVj6F/vx8ijEWivNeyZeyoqjJDg8bdj9BZ7Ia4LCJ24TCwR7xBXiDeJOYFEMYGDkwOV5cInmDWyENeUwN1LkGJTL1Mq20ZTUNvR5JsjE1txlUg5qW1XVArWf9QhFgLB7Xhb0VmnBKr1qiuY0BOXL/OGwMzzGcy+mIXIu/e5p1Jwv75vD8Cb1Io0lK5il0xkTD+ddndKGrsfd2mIH5Yhip4kh1E7TguY300pdv733N8mmv68MQ8x9WzKtoY3kckN964LAhkjI8UYk+uTtpWc57T7oY0hiOSDpP8Bk9dXiOw7dW/w1qCSAkqVEsSS+0ySKordi0UI0m6H7w/LxImHE7a5rwqc/TmT96zflu3VYAWOYKhkKo2b6yC5kkTBKKgVMLA6EN0iLvkxlRw1lO6lblg/LSUBXPy7kNe192sQmj+2SRrKnDGnbOPxkyS9rUPrwGnjVAoxjr4etbeXYxsO7tP7wjYh0c5MJxq/GlIwnov7vw6HKq9pbP6Rnx43OhjMjecSs8SgE7ykT6/2peYKMhZ3FsOHg7NrvgYr4LU6HNLbaaXiEWRor+jEWVDB3uRWbHd8OTAt0z1gefpsES6XX8L/1QHLMYcnhyrLRUjQQe1zDfo7HeNb4+gp9yBejmNscwy5NzlUzIqKCgL4D5w6fRuzhxaDAAAAAElFTkSuQmCC";

  myInterval=null;
  private loading: any = null;
  private sync: any = null;
  ///////////////////////////////////////////////
  public fileUrl: SafeResourceUrl;
  public rutadoc="";
  public listdoc=true;
  public uuid:String='';
  public proyusu="";//"1665633551";
  public proyecto="";
  public tipousu="";
  public tareas=[];

  options : InAppBrowserOptions = {
    location : 'no',//Or 'no' 
    hidden : 'no', //Or  'yes'
    clearcache : 'yes',
    clearsessioncache : 'yes',
    zoom : 'yes',//Android only ,shows browser zoom controls 
    hardwareback : 'yes',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Close', //iOS only
    disallowoverscroll : 'no', //iOS only 
    toolbar : 'yes', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'pagesheet',//iOS only 
    fullscreen : 'yes',//Windows only    
  };

  public imagedoc="";
  public imgestado=false;

  public tblproyectos=[];
  public tblusuarios=[];
  public tblproyusu=[];
  public tblfaseproy=[];
  public tblmovimientos=[];


  public tbltareas=[];
  public tbltareassin=[];   // pendiente por sinconizar si storage
  public tbltareastotal=[]; // variable interna --> no storage



  public tblitemstareas=[];
  public tblitemstareassin=[];   // pendiente por sinconizar si storage
  public tblitemstareastotal=[]; // variable interna --> no storage


  public tblhextras=[];
  public tblhextrassin=[];   // pendiente por sinconizar si storage
  public tblhextrastotal=[]; // variable interna --> no storage

  //variables par unidades internacionales einglesas....
  public unilog=[]; // 1. longuitud
  public uniare=[]; // 2. area 
  public univol=[]; // 3. Volumen
  public unitem=[]; // 4. Temperatura
  public unifue=[]; // 5. Fuerza

  public folderes=[];
  public carpetafolderes="";
  public recur=true;

  public derechos=true;
  public fact="2023-01-20 12:00:00";  /// verifica que no tenga mas de 15 dias sin actualizar...
  public version="1"; // version del aplicativo

  public visarbol=true;
  public seldatasheet=[
    {'info':
    {'info':
    {planta:'',proceso:'',actfijo:'',marca:'',modelo:'',serie:'',teq:''}
  
  }}];

public seldatasheetorig=[];

  public plantas=[];
  public sistemas=[];
  public tipoequipos=[];

  public getimglogo='../../../assets/img/logoappdoc2.png';
 // public getimglogo2='../../../assets/img/fondopeaje2.png';
  ////////////////////////////////

 
  public consql: consql

  public empresas=[]; // empresas de dms
  public inspecciones=[] // inspecciones


  ////////////////////////////////


  
  public tblproycomp=[];
  public tblempresas=[];
  public fases=0;

  public paso=1;

  public aprob= 0
  public pendi= 0;
  public recha= 0;
  public todas=0;


  public database: SQLiteObject;

  ///////////////////////////////////////////////
  public docurl="";

  info={
    usuario:[],
    proyecto:[],
    sincronizacion:new Date().getTime()
   // trabajos:[],
   // hextras:[],
   // fechas:[],
 
  }; 

  

  //const d = new Date();
  //document.getElementById("demo").innerHTML = d.getTime();

/*getFullYear()	Get the year as a four digit number (yyyy)
getMonth()	Get the month as a number (0-11)
getDate()	Get the day as a number (1-31)
getHours()	Get the hour (0-23)
getMinutes()	Get the minute (0-59)
getSeconds()	Get the second (0-59)
*/

//////////////////////////////////////////////////////////////////

 public hr='<hr style="height: 0px; border-width: 1px;position: absolute; width: 100%; left: 0;    margin: 0;">';



 public poros=[
  {'id':1,'texto':'Poros ','label':'Poros '+this.hr,'tipo':5,"padre":-1},   
  {'id':2,'texto':'Tiene poros','label':'Tiene poros'+this.hr,'tipo':3,"padre":-1},
  {'id':3,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
  {'id':4,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
  {'id':5,'texto':'Fin','label':'Fin'+this.hr,'tipo':2,"padre":-1},
  {'id':6,
  'texto':'Realizar medición y tomar evidencia  <br> 1. Dimensión del poro: <br> 2. Longitud: ',
  'label':'Realizar medición y tomar evidencia <br> 1. Dimensión del poro:  <br> 2. Longitud:'+this.hr,
  'tipo':2,"padre":-3,
  'info':[
  {'texto':'1. Dimensión del poro:',"id":"","tipo":"number","unidades":"1","uniid":{"id":"1","descripcion":"M"}},
  {'texto':'2. Longitud:',"id":"","tipo":"number","unidades":"1","uniid":{"id":"1","descripcion":"M"}},
  ],
  'result':[]},
  {'id':7,'texto':'Registro de imperfeccion','label':'Registro de imperfeccion'+this.hr,'tipo':3,"padre":-1}
  ]

 public  socavacion=[
    {'id':1,'texto':'socavación','label':'socavación '+this.hr,'tipo':5,"padre":-1},   
    {'id':2,'texto':'Tiene socavación','label':'Tiene socavación'+this.hr,'tipo':3,"padre":-1},
    {'id':3,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
    {'id':4,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
    {'id':5,'texto':'Fin','label':'Fin'+this.hr,'tipo':2,"padre":-1},
    {'id':6,'texto':'Realizar medición y tomar evidencia <br>  1. Dimensión de la socavación (1/32") no superar','label':'Realizar medición y tomar evidencia <br>  1. Dimensión de la socavación (1/32") no superar'+this.hr,'tipo':2,"padre":-3},
    {'id':7,'texto':'Registro de imperfeccion','label':'Registro de imperfeccion'+this.hr,'tipo':3,"padre":-1}
    ]

public agrietamiento=[
      {'id':1,'texto':'Agrietamiento','label':'Agrietamiento '+this.hr,'tipo':5,"padre":0},   
      {'id':2,'texto':'Tiene Agrietamiento','label':'Tiene Agrietamiento'+this.hr,'tipo':3,"padre":-1},
      {'id':3,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
      {'id':4,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
      {'id':5,'texto':'Fin','label':'Fin'+this.hr,'tipo':2,"padre":-1},       
      {'id':6,'texto':'Registro de imperfeccion','label':'Registro de imperfeccion'+this.hr,'tipo':3,"padre":-3},
      {'id':7,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':2,"padre":-1}
      ]

public abolladuras=[
        {'id':1,'texto':'Abolladuras ','label':'Abolladuras '+this.hr,'tipo':5,"padre":0},   
        {'id':2,'texto':'Tiene Abolladuras en la soldadura o cerca','label':'Tiene Abolladuras en la soldadura o cerca'+this.hr,'tipo':3,"padre":-1},
        {'id':3,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
        {'id':4,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
        {'id':5,'texto':'Fin','label':'Fin'+this.hr,'tipo':2,"padre":-1},       
        {'id':6,'texto':'1. Mide la distancia desde la abolladura hasta el cordon <br> 1. Registro deldefecto <br> 2. Diámetro <br>3. Profundidad','label':'1. Mide la distancia desde la abolladura hasta el cordon <br> 1. Registro deldefecto <br> 2. Diámetro <br>3. Profundidad'+this.hr,'tipo':3,"padre":-3},
        {'id':7,'texto':'Es menor de 3 cm','label':'Es menor de 3 cm'+this.hr,'tipo':3,"padre":-1},
        {'id':8,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
        {'id':9,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
        {'id':10,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-2}
        ]

public abolladuras2=[
          {'id':1,'texto':'Hay abolladura ','label':'Hay abolladura'+this.hr,'tipo':3,"padre":0},   
          {'id':2,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
          {'id':3,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
          {'id':4,'texto':'Finalizo','label':'Finalizo'+this.hr,'tipo':3,"padre":-1},

          {'id':5,'texto':'En las cabezas','label':'En las cabezas'+this.hr,'tipo':3,"padre":-3},   
          {'id':6,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
          {'id':7,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
          {'id':8,'texto':'1. Mide diámetro promedio de la abolladura <br> 2. mide la profundidad de la abolladura “x”<br>3. diámetro del tanque','label':'1. Mide diámetro promedio de la abolladura <br> 2. mide la profundidad de la abolladura “x”<br>3. diámetro del tanque'+this.hr,'tipo':3,"padre":-2},
          {'id':9,'texto':'1. Mide diámetro promedio de la abolladura <br> 2. mide la profundidad de la abolladura','label':'1. Mide diámetro promedio de la abolladura <br> 2. mide la profundidad de la abolladura'+this.hr,'tipo':3,"padre":-2},
         
          ];

public abolladuras2_1=[
          {'id':1,'texto':'La profundidad es mayor de 6.35mm','label':'La profundidad es mayor de 6.35mm'+this.hr,'tipo':3,"padre":0},   
          {'id':2,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
          {'id':3,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},

          {'id':4,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
          {'id':5,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},

          
          {'id':6,'texto':'DP es mayor (1/10) de la misma','label':'DP es mayor (1/10) de la misma'+this.hr,'tipo':3,"padre":-3},   
          {'id':7,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
          {'id':8,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},

          {'id':9,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
          {'id':10,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},

          {'id':11,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-3},        
        
          ];

public abolladuras2_2=[
            {'id':1,'texto':'La profundidad es mayor de 6.35mm','label':'La profundidad es mayor de 6.35mm'+this.hr,'tipo':3,"padre":0},   
            {'id':2,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':3,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
  
            {'id':4,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
            {'id':5,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},
  
            
            {'id':6,'texto':'DP es mayor (1/10) de la misma','label':'DP es mayor (1/10) de la misma'+this.hr,'tipo':3,"padre":-3},   
            {'id':7,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':8,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
  
            {'id':9,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
            {'id':10,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},
  
            {'id':11,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-3},        
          
            ];

public Abombamientos=[
            {'id':1,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":0},
            {'id':2,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1}
          ];

public Corrosion=[
            {'id':1,'texto':'1. Toma distancia de la picadura <br> 2. Toma profundidad de la picadura','label':'1. Toma distancia de la picadura <br> 2. Toma profundidad de la picadura'+this.hr,'tipo':3,"padre":0},


            {'id':2,'texto':'Supera 76 mm lineal','label':'Supera 76 mm lineal'+this.hr,'tipo':3,"padre":-1},   
            {'id':3,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':4,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},

            {'id':5,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
            {'id':6,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},

            {'id':7,'texto':'Fin','label':'Fin'+this.hr,'tipo':3,"padre":-3},

            {'id':8,'texto':'Supera 15% espesor','label':'Supera 15% espesor'+this.hr,'tipo':3,"padre":-7},   
            {'id':9,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':10,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},

            {'id':11,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
            {'id':12,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},     

            {'id':13,'texto':'Espesor remanente menor 3.18mm','label':'Espesor remanente menor 3.18mm'+this.hr,'tipo':3,"padre":-12},   
            {'id':14,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':15,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},

            {'id':16,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":-2},
            {'id':17,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1},


          ];

public Accion_del_Fuego=[
            {'id':1,'texto':'Registro','label':'Registro Fotografico'+this.hr,'tipo':3,"padre":0},
            {'id':2,'texto':'Rechazo','label':'Rechazo'+this.hr,'tipo':3,"padre":-1}
          ];


Sobrenaso=[
            {'id':1,'texto':'1. Verificar no existan gritas <br> 2. Verificar que no tengas espacios','label':'1. Verificar no existan gritas <br> 2. Verificar que no tengas espacios'+this.hr,'tipo':3,"padre":0},
            {'id':2,'texto':'Registro','label':'Registro'+this.hr,'tipo':3,"padre":-1},

            {'id':3,'texto':'Defectos','label':'Defectos'+this.hr,'tipo':3,"padre":-1},   
            {'id':4,'texto':'Si','label':'Si'+this.hr,'tipo':3,"padre":-1},
            {'id':5,'texto':'No','label':'No'+this.hr,'tipo':3,"padre":-2},
            {'id':5,'texto':'Mantenimiento','label':'Mantenimiento'+this.hr,'tipo':3,"padre":-2},
          ];


ramas=[];



/////////////////////////////////////////////////////////////////


public ventanaAncho = window.innerWidth;
public ventanaAlto = window.innerHeight;




private renderer: Renderer2;
  constructor(
    private fingerprint: FingerprintAIO,
    private inAppBrowser: InAppBrowser,
    private sanitizer: DomSanitizer,
    private file: File,
    private sqlite: SQLite,
    public rendererFactory: RendererFactory2,
    private nativeStorage: NativeStorage,
    private modalCtrl:  ModalController,
    private platform: Platform,
    private http: HttpClient,
    public popoverController: PopoverController,
    private ToastCtrl: ToastController,
    private loadingController: LoadingController,
    private navCtrl: NavController,
    private menus: MenuComponent,
    //private verdocu: VerdocumentosPage,
    //private camera: Camera
  )
  
  { 


    window.addEventListener('resize', ()=> {
      console.log('El tamaño de la ventana ha cambiado.');
      console.log('Ancho actual:', window.innerWidth);
      console.log('Alto actual:', window.innerHeight);
      this.ventanaAncho = window.innerWidth;
      this.ventanaAlto = window.innerHeight;
  });




    //this.basededatos();  
    //crea la conexion con la bd sql
    //this.consql=new consql(this.sqlite); 


    this.renderer = this.rendererFactory.createRenderer(null, null);  
     
  
 
 this.unilog=[{"id":"1","descripcion":"M"},{"id":"2","descripcion":"In"},{"id":"3","descripcion":"Ft"}]

 ///////////////////////////////////////////////////////////////////////

// creamos las ramas

this.ramas[0]=this.poros;
this.ramas[1]=this.socavacion;
this.ramas[2]=this.agrietamiento;
this.ramas[3]=this.abolladuras;
this.ramas[4]=this.abolladuras2;
this.ramas[5]=this.abolladuras2_1;
this.ramas[6]=this.abolladuras2_2;
this.ramas[7]=this.Abombamientos;
this.ramas[8]=this.Corrosion;
this.ramas[9]=this.Accion_del_Fuego;
this.ramas[10]=this.Sobrenaso;
//this.ramas[10]=this.ros;






////////////////////////////////////////////////////////////////////////


//**************************************************************************************************************//



/*


this.cp.agregar({'id':13,'texto':'Corrosion','label':'Corrosion'+this.hr,'tipo':5,"padre":9});

this.cp.agregar({'id':14,'texto':'Acción del Fuego','label':'Acción del Fuego'+this.hr,'tipo':5,"padre":9});

this.cp.agregar({'id':15,'texto':'Sobrenaso','label':'Sobrenaso'+this.hr,'tipo':5,"padre":9});

this.cp.agregar({'id':16,'texto':'Roscas','label':'Roscas'+this.hr,'tipo':5,"padre":9});


*/



///////////////////////////////////////////////////////////////////////
/*
var pos=6;
    var ini=17;

    this.modificar(ini,this.poros,pos);
    ini+=this.poros.length;
    pos+=this.poros.length;

   this.modificar(ini,this.socavacion,pos);
   ini+=this.socavacion.length+1;
   pos+=this.socavacion.length+2;

   this.modificar(ini,this.agrietamiento,pos);
   ini+=this.agrietamiento.length+1;
   pos+=this.agrietamiento.length+1;

   this.modificar(ini,this.abolladuras,pos);
   ini+=this.abolladuras.length+1;
   pos+=this.abolladuras.length;

   this.modificarpos(ini,this.abolladuras2,11);
  
   ini+=this.abolladuras2.length+1;
   pos+=this.abolladuras2.length;

   this.modificar(ini,this.abolladuras2_1,pos);

   

 //  this.modificar(ini,this.abolladuras2,ini-pos-11);
  */

//this.cp.cargarmasivo(this.cp.getdata());

   
     console.log("cpcpcpcpcpcpcpp");

     

     //this.cp.setnombre("");
     //this.cp.getnombre();

      this.setuuid();

     
     
    
  }

  
menuset(perfil){

//this.tipousuario
  this.menus. menuset(this.tipousuario,perfil,this.plantadescripcion);
  
  }

  setnombreusuario(n){
    this.nombreusuario=n;

  }

  getnombreusuario(){
    return this.nombreusuario;
  }

  setusuario(u){
  this.usuario=u;
  }

  getusuario(){
   return  this.usuario;
    }


  settipousuario(tu){
  this.tipousuario=tu;
  }

  gettipousuario(){
  return  this.tipousuario;
  
    }

  setplanta(p){
  this.plantaid=p

  }

  setplantades(p){
    this.plantadescripcion=p;
  
    }  

  getplanta(){
   return  this.plantaid
    }

  
    getplantades(){
      return  this.plantadescripcion;
       }
   
 



  rutas(){

console.log("549 --> rutas :");
console.log("this.file.externalRootDirectory");
console.log(this.file.externalRootDirectory);
console.log("this.file.externalDataDirectory");
console.log(this.file.externalDataDirectory);



  }



 carpeta(){

 var rutaBd="";

 console.log("creando carpeta");

  this.file.checkDir(this.file.externalRootDirectory, 'aplicaciondmsv2').then(respuesta => {
   // rutaBd = this.file.externalRootDirectory + "/aplicaciondms"
  }).catch(err => {
    this.file.createDir(this.file.externalRootDirectory, "aplicaciondmsv2", true).then(valor => {
   //  rutaBd = this.file.externalRootDirectory + "/aplicaciondms"
    })
  });

  
console.log("--> ruta bd");
console.log("ruta: --> "+rutaBd);

  this.sqlite.create({
    name: 'dms.bd',
    location: "/storage/emulated/0/aplicaciondmsv2/"
  }).then((db: SQLiteObject) => {

    this.database = db;  
    db.executeSql("create table if not exists items"+
    "(reference CHAR(10) PRIMARY KEY,"+
    "name CHAR(30),"+
    "qMin FLOAT,"+
    "qReal FLOAT)", [])
    .then(() => console.log('Executed SQL'))
    .catch(e => console.log(e));
  })
  .catch(e => console.log("572"+JSON.stringify(e)));


  
 }
/*
  decrypt(ciphertext, key) {
  let ciphertext_dec = atob(ciphertext);
  let iv = ciphertext_dec.substr(0, 16);
  let hmac = ciphertext_dec.substr(16, 32);
  let ciphertext_raw = ciphertext_dec.substr(48);

  let calculated_hmac = CryptoJS.HmacSHA256(ciphertext_raw, key).toString(CryptoJS.enc.Hex);
  if (calculated_hmac !== hmac) {
      throw new Error('HMAC verification failed');
  }

  let decipher = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(ciphertext_raw) }, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });

  return decipher.toString(CryptoJS.enc.Utf8);
}*/

/*
encrypt(text: string, key: string, iv: string): string {
  const cipherText = CryptoJS.AES.encrypt(text, key, { iv: CryptoJS.enc.Hex.parse(iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return cipherText.toString();
}

decrypt(cipherText: string, key: string, iv: string): string {
  const decrypted = CryptoJS.AES.decrypt(cipherText, key, { iv: CryptoJS.enc.Hex.parse(iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
*/

encryptData(data: string, key: string, ivBase64: string): string {
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(ivBase64);

  const encrypted = CryptoJS.AES.encrypt(data, keyUtf8, { iv });

  return encrypted.toString();
}

decryptData(encryptedData: string, key: string, ivBase64: string): string {
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(ivBase64);

  const decrypted = CryptoJS.AES.decrypt(encryptedData, keyUtf8, { iv });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

// Example usage
performEncryptionDecryption() {
  const dataToEncrypt = 'Hello, Ionic!';
  const encryptionKey = 'yourEncryptionKey';
  const ivBase64 = 'yourBase64IVString';

  const encryptedData = this.encryptData(dataToEncrypt, encryptionKey, ivBase64);
  console.log('Encrypted Data:', encryptedData);

  const decryptedData = this.decryptData(encryptedData, encryptionKey, ivBase64);
  console.log('Decrypted Data:', decryptedData);
}

encryptData2(data: string, key: string, ivBase64: string): string {
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(ivBase64);

  const encrypted = CryptoJS.AES.encrypt(data, keyUtf8, { iv });

  return encrypted.toString();
}

decryptData2(encryptedData: string, key: string, ivBase64: string): string {
  const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  
  var  tt=CryptoJS.enc.Base64.parse("MWZZL1Roak45emdzMGhOVlZnRW9kZDZ1bEtXRHh2dUFJZFZyMkJFZTk1MzJ5MTVQNi9hRTVCRXJCVTkyVnJMUA==");

  const decrypted = CryptoJS.AES.decrypt({encryptedData}, keyUtf8, { iv });

  return decrypted.toString(CryptoJS.enc.Utf8);
}



decrypt2( key) {
  //const iv = atob("NHHSH33sptkYX90zk0kWvA==");
  //const encryptedText = atob("MWZZL1Roak45emdzMGhOVlZnRW9kZDZ1bEtXRHh2dUFJZFZyMkJFZTk1MzJ5MTVQNi9hRTVCRXJCVTkyVnJMUA==");
  const decipher = CryptoJS.AES.decrypt({ ciphertext: '3166592f54686a4e397a677330684e565667456f646436756c4b57447876754149645672324245653935333279313550362f6145354245724255393256724c50'}, key, { iv: '3471d21f7deca6d9185fdd33934916bc' });
  return decipher.toString(CryptoJS.enc.Utf8);
}

encrypt (text: string, key: string, iv: CryptoJS.WordArray): string  {
    const cipherText = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return cipherText.toString();
  }

  decryptText(encryptedText: string, key: string, iv: CryptoJS.WordArray): string {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }






decrypt(){}


 setfileurl(url){

  url=url.replaceAll("./","/");
  
  //https://drive.google.com/viewerng/viewer?url=
  //"https://oilandgas.com.co"+url

  

  var xx=encodeURI("https://oilandgas.com.co"+url);
  //this.inAppBrowser.create(xx, '_system',this.options);

  
  //this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://docs.google.com/gview?url="+xx+"&embedded=true");
 // this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://docs.google.com/gview?url="+xx+"&embedded=true");

 //this.fileUrl =this.sanitizer.bypassSecurityTrustResourceUrl(xx);

 this.fileUrl =this.sanitizer.bypassSecurityTrustResourceUrl(xx);


  var resu=url.split('/');
  //this.fileUrl = url;
  this.docurl=resu[resu.length-1];

  console.log (encodeURI(url));


 // this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://drive.google.com/viewerng/viewer?url="+xx);
//console.log(this.fileUrl);
}



  basededatos(){

    
   

  /*
    console.log('creando base de datos dms2.db');
    this.sqlite.create({
      name: '/sdcard/mydatabasez.db',
      location: 'default'
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));
    })
    .catch(e => console.log("560"+JSON.stringify(e)));
*/
    

  }

  async bssdcar(ruta){

    try {
      
    

    const dbName = ruta+'/mysdionic.db'; //'/storage/F194-12FB/mysdionic.db';
    const dbFilePath = ruta + dbName;
    const dbFilePath2 = ruta +"/"+ dbName;
    console.log('creando base de datos');


   var res= await this.sqlite.create({
      name:dbName,
      location:'default',
     // androidDatabaseLocation: ruta
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => {console.log('Executed SQL');  return(0);})
      .catch(e => {console.log(e); return (1);})
    })
    .catch(e => {console.log("584"+JSON.stringify(e)); return (2); });

  } catch (error) {
      
  }

/*
    this.sqlite.create({
      name:dbName,
      location:'default',
      androidDatabaseLocation: dbName
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));
    })
    .catch(e => console.log("584"+JSON.stringify(e)));

 */   

    

  }

  basededatos2(){
    const dbName = 'mydatabase.db';
    const dbFilePath = this.file.externalDataDirectory + dbName;
    console.log('creando base de datos');
    this.sqlite.create({
      name: dbName,
      location: this.file.externalDataDirectory,
      //createFromLocation: 1,
      androidDatabaseLocation: dbFilePath
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));
    })
    .catch(e => console.log("584"+JSON.stringify(e)));

    

  }


  basededatos3(){

    console.log('creando base de datos');
    this.sqlite.create({      
      name: 'mydbexternal.db',
      location: '/sdcard/',
      androidDatabaseLocation: '/sdcard/'
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));
    })
    .catch(e => console.log("609"+JSON.stringify(e)));

    

  }

  basededatos4(){

   // Initialize the database


  let dbFilePath = this.file.externalRootDirectory + 'mydatabase4.db'; // Set the database file path
  this.sqlite.create({
    name: 'mydatabase4.db',
    location: this.file.externalRootDirectory,
    //createFromLocation: 1,   
    androidDatabaseLocation: dbFilePath // Set the database file path for Android
  })
  .then((db: SQLiteObject) => {

    this.database = db;  
    db.executeSql("create table if not exists items"+
    "(reference CHAR(10) PRIMARY KEY,"+
    "info LONGTEXT,"+
    "name CHAR(30),"+
    "qMin FLOAT,"+
    "qReal FLOAT)", [])
    .then(() => console.log('Executed SQL'))
    .catch(e => console.log(e));
  })
  .catch(e => console.log("633"+e));



  }


   basededatos5(){
    

    console.log('creando base de datos');
    this.sqlite.create({
      name: 'dmsext.db',//Este equipo\Redmi 6\Tarjeta SD\Android\data\io.ionic.starter
      location: 'external',
     
    }).then((db: SQLiteObject) => {

      this.database = db;  
      db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));
    })
    .catch(e => console.log("660 "+e));

    

  }


  basededatostotal(){

    console.log('creando base de datos');
    this.sqlite.create({
      name: 'dms.db',
      location: 'default'
    }).then((db: SQLiteObject) => {

      this.database = db;  
  /*    db.executeSql("create table if not exists items"+
      "(reference CHAR(10) PRIMARY KEY,"+
      "info LONGTEXT,"+
      "name CHAR(30),"+
      "qMin FLOAT,"+
      "qReal FLOAT)", [])
      .then(() => console.log('Executed SQL'))
      .catch(e => console.log(e));*/

      //tabla usuarios
      db.executeSql("create table if not exists usuarios"+
      "(id INT AUTO_INCREMENT,"+         
      "uuid CHAR(15),"+
      "info LONGTEXT,"+
      "fact DATETIME, PRIMARY KEY (id))", []) //CONSTRAINT PK_Usuarios
      .then(() => console.log('Executed SQL Usuarios'))
      .catch(e => console.log(e));

       //tabla empresas
       db.executeSql("create table if not exists empresas"+
       "(id CHAR(15),"+         
       "uuid INT,"+
       "info LONGTEXT,"+
       "fact DATETIME,"+
       "empresa CHAR(45),UNIQUE (empresa), PRIMARY KEY (id,uuid))", []) //CONSTRAINT PK_Empresas
       .then(() => console.log('Executed SQLEmpresas'))
       .catch(e => console.log(e));


        //tabla equipos
        db.executeSql("create table if not exists equipos"+
        "(id CHAR(15),"+         
        "uuid INT,"+
        "info LONGTEXT,"+
        "fact DATETIME,"+
        "equ CHAR(20),"+
        "emp CHAR(15),"+
        "PRIMARY KEY (id,uuid))", []) //CONSTRAINT PK_Equipos
        .then(() => console.log('Executed SQL Equipos'))
        .catch(e => console.log(e));


         //tabla herramientas
         db.executeSql("create table if not exists herramientas"+
         "(id CHAR(15),"+         
         "uuid INT,"+
         "info LONGTEXT,"+
         "fact DATETIME,"+             
         "PRIMARY KEY (id,uuid))", []) //CONSTRAINT PK_Equipos
         .then(() => console.log('Executed SQL Herramientas'))
         .catch(e => console.log(e));


         //tabla Instruentos
         db.executeSql("create table if not exists instrumentos"+
         "(id INT AUTO_INCREMENT,"+         
         "descripcion CHAR(15),"+                       
         "UNIQUE (descripcion),PRIMARY KEY (id))", []) //CONSTRAINT PK_Equipos
         .then(() => console.log('Executed SQL Instrumentos'))
         .catch(e => console.log(e));


         //tabla herramientas
         db.executeSql("create table if not exists inspecciones"+
         "(id CHAR(15),"+         
         "uuid INT,"+
         "info LONGTEXT,"+
         "fact DATETIME,"+             
         "PRIMARY KEY (id,uuid))", []) //CONSTRAINT PK_Equipos
         .then(() => console.log('Executed SQL Inspecciones'))
         .catch(e => console.log(e));


         //tabla soportes
         db.executeSql("create table if not exists soportes"+
         "(id CHAR(15),"+         
         "img LONGTEXT,"+
         "estado INT,"+
         "PRIMARY KEY (id))", []) //CONSTRAINT PK_Soportes
         .then(() => console.log('Executed SQL Soportes'))
         .catch(e => console.log(e));





    })
    .catch(e => console.log(e));

    

  }




  removebasededatos(){

    console.log('creando base de datos');
    this.sqlite.deleteDatabase({
      name: 'dms.db',
      location: 'default'
    }).then( (data)=> {
      console.log("Se elimino la BD");
      console.log(JSON.stringify(data));      
    })
    .catch(e => {
      console.log("Eror eliminado la BD");
      console.log(JSON.stringify(e)) });

    

  }



/*
  async camara(){
     
    const options: CameraOptions = {
      quality: 100,this.buffer=new clsinpecciones(this.nativeStorage,this.plataforma()[0].desktop,  Device.getId());
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
  this.camera.getPicture(options).then((imageData) => {
    var foto = 'data:image/jpeg;base64,' + imageData;

   
    var d = new Date();
    var n = d.getTime();
    console.log("foto--->");
    console.log(foto);
    console.log({name:"foto"+n,img:foto,estado:0});
 
    //this.pothos.push
    return ({name:"foto"+n,img:foto,estado:0});
    //this.nomarch.push("foto"+n);
    // this.pothos.push({name:file.name,img:reader.result});
    
  }, (err) => {
    console.log(err);
    return {estado:1};
    this.mensaje('No se puede capturar la foto...','danger')
  });




   
    
  }
*/




  getuni(u){

  var unidadades=[];

if(u=="1"){unidadades=this.unilog;}
if(u=="2"){unidadades=this.uniare;}
if(u=="3"){unidadades=this.univol;}
if(u=="4"){unidadades=this.unitem;}
if(u=="5"){unidadades=this.unifue;}
 return unidadades;

  }

  async modificar(inicio,hoja,pos){

    var id=inicio;
    var sig=0;
    hoja.filter(x=>{   
      x.id=id;    
      if(sig==0)
      x.padre=x.padre+id-pos;  
      else    
      x.padre=x.padre+id
      id++;
      sig++;
    })

    console.log(hoja);

    

  }

  modificarpos(inicio,hoja,pos){

    var id=inicio;
    var sig=0;
    hoja.filter(x=>{   
      x.id=id;    
      if(sig==0)
      x.padre=pos;  
      else    
      x.padre=x.padre+id
      id++;
      sig++;
    })

    console.log(hoja);

  

  }


  gettree(){



  }

  async presentToast(message:string,color:string){
    const toast= await this.ToastCtrl.create({
    color,
    position: 'bottom',
    message,
    duration:2000
    });
  
    toast.present();
  
    }


    async verificarfinger(){  
  
      var vfhh = await this.fingerprint.isAvailable()
      .then(response => {   return true;} )
      .catch(err => {    return err;})
     
      console.log("apiverificando...");
      console.log("codigo finger:"+vfhh.code);  
      if(typeof vfhh === 'undefined'){ return false }          
     
      return vfhh; 
      
        
       }

 
async finger() {   

  const myfinger=await this.fingerprint.show({
     
     cancelButtonTitle: 'Cancel',
     description: "Seguridad AppDocumentos",
     disableBackup: true,
     title: 'Configuracion de Huella',
     fallbackButtonTitle: 'FB Back Button',
     subtitle: ''
   
      })
 .then((result: any) => 
 { //this.mensaje('Se verifico','success')
  return true
 })
 .catch((error: any) =>
 { 
 //this.mensaje('No se verifico','danger')
 return false
 });    
     return  myfinger ;
 
 
 }
 


  mensaje(mensaje,color){

    this.presentToast(mensaje,color);
  }

  settipousu(tipousu){
    this.tipousu=tipousu;
  }

  setproyusu(proyusu){
    this.proyusu=proyusu;
  }

  setproyecto(proyecto){
    this.proyecto=proyecto;    
  }


  getdespro(idproy){

 // console.log(idproy);
 // console.log(this.tblfaseproy);
  var idpro=this.tblfaseproy.find(x=> x.id===idproy);
 // console.log( idpro);
 // console.log(this.tblproyectos);
  var proy= this.tblproyectos.find(x=> x.id===idpro.info.info.proyecto);  
 // console.log(proy);

  return proy.info.info.descripcion;



  }
  async setuuid(){

    console.log("buscando uuid");
    const info = await Device.getId(); 
    this.uuid=info.uuid;
    console.log(this.uuid);


//// si lega  acambiar el uuid lo guardo...

console.log("Plataforma : " + this.plataforma()[0].desktop);

if(this.plataforma()[0].desktop ==0) {
    
  const llave= await this.nativeStorage.getItem('uuid')
  .then(
    data => { 
        this.uuid=data['uuid'];
     }
    ,
    error => {          
      
      this.nativeStorage.setItem('uuid', {
        uuid:info.uuid
      })
      .then(
        () => {       
         this.uuid=info.uuid;  //informacion actualizada....      
        },
        error =>{
          this.uuid=String(info.uuid)
         // this.mensaje("Error cargando UUID","danger");
           }
      );
  
    }
  ); 

  }else{     
        
    var guardado = localStorage.getItem('uuid');     

    console.log(guardado);
  
    if(guardado!=null){
       
      console.log("verificando guardado...");       
      this.uuid=guardado 

    }
    else{

      localStorage.setItem('uuid', info.uuid);
      this.uuid=info.uuid;
      
    }


  }

 



  



////////////////////////////////////////////

    //this.sincronizar();
  
  }
  
  
  getuuid(){
    return this.uuid;
  }

cargacompleta(){

  setTimeout(() => {

    this.closedloading();
  console.log(this.tblusuarios)
  if(this.tblusuarios.length>0){
  // this.navCtrl.navigateForward('/inicio');
  }



  
    
  }, 1500);

}


buscartot(trabajo,estado){

  //return this.tblfaseproy.find(x=> Number(x.id)==Number(fase))['descripcion'];
  
 var fil1= this.tblitemstareastotal.filter(x => Number(x.info.info.idtarea)== Number(trabajo))
  
  return fil1.filter(x => Number(x.info.info.estado)== estado).length


  }

buscarfase(fase){

return this.tblfaseproy.find(x=> Number(x.id)==Number(fase))['descripcion'];
     
}

  async sincronizarmovimientosbajada(){

    (await this.getapi(10)).subscribe(info => {  

      //////////////////////////////
      console.log("Tabla-Movimientos");
      console.log(info);
    
      if(this.plataforma()[0].desktop ==0) {
    
          this.tblmovimientos=  this.gettablaapp(info,'tblmovimientos');
    
        }else{      
          this.tblmovimientos= this.gettabla(info,'tblmovimientos');
        }
    
      //////////////////////////////
     
    }, (error) => {
    
     console.log(error);
    
     //////////////////////////////
    
     if(this.plataforma()[0].desktop ==0) {
    
      this.tblmovimientos= this.gettablaapp([],'tblmovimientos');
    
       }else{      
        this.tblmovimientos=  this.gettabla([],'tblmovimientos');
       }
    
     //////////////////////////////
    
    
    
     
    },()=>{
     
    } );

  }

  async sincronizartareasbajada(){

    (await this.getapibus(6,this.uuid)).subscribe(info => {  

      //////////////////////////////
      console.log("Tabla-Tareas");
      console.log(info);
    
      if(this.plataforma()[0].desktop ==0) {          
        this.tbltareas= this.gettablaapp(info,'tbltareas');   
        this.tbltareassin= this.gettablaapp([],'tbltareassin'); 
        }else{      
        this.tbltareas= this.gettabla(info,'tbltareas');
        this.tbltareassin= this.gettabla([],'tbltareassin');
        }
    
        
      //////////////////////////////
     
    }, (error) => {
    
     console.log(error);
    
     //////////////////////////////
    
     if(this.plataforma()[0].desktop ==0) {    
      this.tbltareas= this.gettablaapp([],'tbltareas');   
      this.tbltareassin= this.gettablaapp([],'tbltareassin'); 
     }else{      
      this.tbltareas=  this.gettabla([],'tbltareas');
      this.tbltareassin= this.gettabla([],'tbltareassin');
     }
    
     //////////////////////////////
    
   // console.log(this.tbltareas);
   console.log(this.tipousu)
   console.log(this.proyusu);
   // console.log(this.proyusu['id']);
   console.log(this.tbltareas);

    if(this.tipousu=="2")
      this.tareas=this.tbltareas.filter(x=> Number(x.info.info.prousu) === Number(this.proyusu));
     else{
      this.tareas=this.tbltareas;
     }

     this.tbltareastotal=[];


     this.tbltareastotal.push(...this.tbltareassin); 

  ////////////////////////////////////////////////////////

     var ids=this.tbltareassin.map(x=> Number(x.id));

     console.log(ids);

     console.log(this.tareas);

     var ite=this.tareas.filter(x=> !ids.includes(Number(x.id)));

     console.log(ite);

     
     //this.tbltareastotal.push(...this.tbltareas);       
     this.tbltareastotal.push(...ite);    
     

  ////////////////////////////////////////////////////////


     

     console.log( this.tbltareastotal);


    this.sincronizaritemstareabajada();
  
     
    },()=>{

      if(this.tipousu=="2")
      this.tareas=this.tbltareas.filter(x=> Number(x.info.info.prousu) === Number(this.proyusu));
     else{
      this.tareas=this.tbltareas;
     }

     this.tbltareastotal=[];


     this.tbltareastotal.push(...this.tbltareassin); 

  ////////////////////////////////////////////////////////

     var ids=this.tbltareassin.map(x=> Number(x.id));

     console.log(this.tbltareassin);
     console.log(ids)

     console.log(this.tareas);

     var ite=this.tareas.filter(x=> !ids.includes(Number(x.id)));

     console.log(ite);

     
     //this.tbltareastotal.push(...this.tbltareas);       
     this.tbltareastotal.push(...ite);    




     // console.log(this.tbltareas);
     // console.log(this.proyusu);
   

      

     this.sincronizaritemstareabajada();

     
    } );

  }

  async sincronizaritemstareabajada(){

    (await this.getapibus(7,this.uuid)).subscribe(info => {  

      //////////////////////////////
      console.log("Tabla-ItemsTareas");
      console.log(info);
    
      if(this.plataforma()[0].desktop ==0) {
    
      this.tblitemstareas=  this.gettablaapp(info,'tblitemstareas');
      this.tblitemstareassin= this.gettablaapp([],'tblitemstareassin'); 
    
        }else{     
      this.tblitemstareas=  this.gettabla(info,'tblitemstareas');
      this.tblitemstareassin= this.gettabla([],'tblitemstareassin'); 
        }
    
      //////////////////////////////
     
    }, (error) => {
    
     console.log(error);
    
     //////////////////////////////
    
     if(this.plataforma()[0].desktop ==0) {
    
      this.tblitemstareas=  this.gettablaapp([],'tblitemstareas');
      this.tblitemstareassin= this.gettablaapp([],'tblitemstareassin'); 
    
       }else{      
        this.tblitemstareas=  this.gettabla([],'tblitemstareas');
        this.tblitemstareassin= this.gettabla([],'tblitemstareassin'); 
       }
    
     ////////////////////////////// 

     this.tblitemstareastotal=[];

     this.tblitemstareastotal.push(...this.tblitemstareassin);
     var lisitetot = this.tblitemstareassin.map(x=> String(x.id));

    console.log("vvvver");
    console.log(lisitetot);
    console.log(this.tblitemstareas);

    var lisitem =   this.tblitemstareas.filter(x=> !lisitetot.includes(String(x.id)));

    console.log(lisitem);


     this.tblitemstareastotal.push(...lisitem);    
     
     this.sincronizarhestrasbajada();
     
    },()=>{

      console.log(this.tblitemstareas);

      this.tblitemstareastotal=[];

      this.tblitemstareastotal.push(...this.tblitemstareassin);
      var lisitetot = this.tblitemstareassin.map(x=> String(x.id));
 
     console.log("vvvver");
     console.log(lisitetot);
     console.log(this.tblitemstareas);
 
     var lisitem =   this.tblitemstareas.filter(x=> !lisitetot.includes(String(x.id)));
 
     console.log(lisitem);
 
 
      this.tblitemstareastotal.push(...lisitem);    

      this.sincronizarhestrasbajada();
     
    } );

  }

  async sincronizarhestrasbajada(){

    (await this.getapibus(8,this.uuid)).subscribe(info => {  

      //////////////////////////////
      console.log("Tabla-hextras");
      console.log(info);
    
      if(this.plataforma()[0].desktop ==0) {
    
      this.tblhextras=  this.gettablaapp(info,'tblhextras');
      this.tblhextrassin= this.gettablaapp([],'tblhextrassin'); 
    
        }else{     
      this.tblhextras=  this.gettabla(info,'tblhextras');
      this.tblhextrassin= this.gettabla([],'tblhextrassin'); 
        }
    
      //////////////////////////////
     
    }, (error) => {
    
     console.log(error);
    
     //////////////////////////////
    
     if(this.plataforma()[0].desktop ==0) {
    
     this.tblhextras=  this.gettablaapp([],'tblhextras');
     this.tblhextrassin= this.gettablaapp([],'tblhextrassin'); 
    
       }else{      
     this.tblhextras=   this.gettabla([],'tblhextras');
     this.tblhextrassin= this.gettablaapp([],'tblhextrassin'); 
       }
    
     //////////////////////////////    

     this.tblhextrastotal=[];

      this.tblhextrastotal.push(... this.tblhextras);
      this.tblhextrastotal.push(... this.tblhextrassin);
    
      this.tblhextrastotal=this.tblhextrastotal.sort(function(a, b){return a.info.info.estado-b.info.info.estado});
    
      this.aprob= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==1).length;
      this.pendi= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==0).length;
      this.recha= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==2).length;
      this.todas= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==-1).length;



     /////////////////////////////
     
    },()=>{


   console.log(this.tblhextras);

   if(this.plataforma()[0].desktop ==0) {    
    //app

    this.nativeStorage.getItem('tblhextrassin')
    .then(
      data => { 
          this.tblhextrassin=data.tblhextrassin
       }
      ,
      error => {          
        
        this.nativeStorage.setItem('tblhextrassin', {
          tblhextrassin: []
        })
        .then(
          () => {       
           this.tblhextrassin=[];  //informacion actualizada....      
          },
          error =>{
           this.tblhextrassin=[];
           console.log("se preentoun error tblhextrasinapp");
             }
        );
      //  console.log("se preentoun error tblhextrasinapp");
    
      this.tblhextrastotal=[];

      this.tblhextrastotal.push(... this.tblhextras);
      this.tblhextrastotal.push(... this.tblhextrassin);
    
      this.tblhextrastotal=this.tblhextrastotal.sort(function(a, b){return a.info.info.estado-b.info.info.estado});
    
      this.aprob= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==1).length;
      this.pendi= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==0).length;
      this.recha= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==2).length;
      this.todas= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==-1).length;

      /////////////////////////////////////////////////////////
      }
    ); 

    ///////////////////////////////////////////
    }else{      
    //destok
   
    var guardado = localStorage.getItem('tblhextrassin'); 
    console.log(guardado);
   // console.log(JSON.parse(guardado.trim()));

    if(guardado!=null){
      //guardado = JSON.parse(guardado);
      console.log("verificando guardado...");
      //console.log(guardado.length);
      this.tblhextrassin=JSON.parse(guardado.trim())  
    }
    else{
      localStorage.setItem('tblhextrassin', JSON.stringify([]));    
      this.tblhextrassin=[];
    }

    ///////////////////////////
    }

  this.tblhextrastotal=[];

  this.tblhextrastotal.push(... this.tblhextras);
  this.tblhextrastotal.push(... this.tblhextrassin);

  this.tblhextrastotal=this.tblhextrastotal.sort(function(a, b){return a.info.info.estado-b.info.info.estado});

  this.aprob= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==1).length;
  this.pendi= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==0).length;
  this.recha= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==2).length;
  this.todas= this.tblhextrastotal.filter(x=> Number(x.info.info.estado)==-1).length;

   









      this.cargacompleta();
     
    } );

  }

  async sincronizarproycompbajada(){

    (await this.getapi(10)).subscribe(info => {  

      //////////////////////////////


      console.log("Tabla-proycomp");
      console.log(info);
    
      if(this.plataforma()[0].desktop ==0) {
    
        this.gettablaproycompapp(info);
    
        }else{     
        this.gettablaproycomp(info);
        }
    
      //////////////////////////////
     
    }, (error) => {
    
     console.log(error);
    
     //////////////////////////////
    
     if(this.plataforma()[0].desktop ==0) {
    
       this.gettablaproycompapp([]);
    
       }else{      
       this.gettablaproycomp([]);
       }
    
     //////////////////////////////    
     
    },()=>{
     
    } );

  }

 

  ////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////





//***********************************************************************
//***********************************************************************



//***********************************************************************
//***********************************************************************


//***********************************************************************
//***********************************************************************


async gettablaproycompapp(info){


  console.log(info);

  if(info.length>0){

    this.nativeStorage.setItem('tblproycomp', {
      tblproycomp: info
    })
    .then(
      () => {       
       this.tblproycomp=info;  //informacion actualizada....      
      },
      error =>{
       this.tblproycomp=[];
       console.log("se preentoun error.");
         }
    );

  }else{

const llave= await this.nativeStorage.getItem('tblproycomp')
.then(
  data => { 
      this.tblproycomp=data.tblproycomp
   }
  ,
  error => {          
    
    this.tblproycomp=[];
    console.log("se preentoun error.");

  }
); 

  }


}


gettablaproycomp(info){

  console.log(info);

  if(info.length>0){

    localStorage.setItem('tblproycomp', JSON.stringify(info));
    this.tblproycomp=info;
  }
  else{

    var guardado = localStorage.getItem('tblproycomp'); 
    if(guardado!=null){

      guardado = JSON.parse(guardado);
      console.log("verificando guardado...");
      //console.log(guardado.length);
      this.tblproycomp=guardado ['tblproycomp']  

    }
    else{
      this.tblproycomp=[];
    }

  }  

}



async ultfase(){

  (await this.getapibus(2,this.uuid)).subscribe(info => {  

    //////////////////////////////
    console.log("Tabla-Usuarios");
    console.log(info);

    
for(var i=0;i<info.length;i++){
  info[i]['descripcion']="("+info[i]['info']['info']['identificacion']+") "+info[i]['info']['info']['nombres'] +" "+info[i]['info']['info']['apellidos'];  
  }
  
    if(this.plataforma()[0].desktop ==0) {  
     this.tblusuarios=  this.gettablaapp(info,"tblusuarios");  
      }else{      
     this.tblusuarios= this.gettabla(info,"tblusuarios");
      }
  
    //////////////////////////////
   
  }, (error) => {
  
   console.log(error);
  
   //////////////////////////////
  
   if(this.plataforma()[0].desktop ==0) {
  
     this.tblusuarios=  this.gettablaapp([],"tblusuarios");
  
     }else{      
     this.tblusuarios= this.gettabla([],"tblusuarios");
     }
  
   //////////////////////////////

   this.sincronizartareasbajada()

  
   
  },()=>{
  



    this.sincronizartareasbajada();
      
   
    
  } );


}


///////////////////////////////////////////////////////
//mejora del codigo 

gettablaapp(info,tbl):any[]{ 

  if(info.length>0){

    this.nativeStorage.setItem(tbl, { //'tblproyectos'
      tbl: info
    })
    .then(
      () => {       
       //this.tblproyectos=info;  //informacion actualizada.... 
       return info;     
      },
      error =>{
       //this.tblproyectos=[];
       return info
       console.log("se preentoun error.");
         }
    );

  }else{

const llave=  this.nativeStorage.getItem(tbl) //
.then(
  data => { 
 return data[tbl]
     //    this.tblproyectos=data.tblproyectos  
   }
  ,
  error => {          
    return [];
  //  this.tblproyectos=[];
    console.log("se preentoun error.");

  }
); 
return [];
  }


}

gettablaappsync(info,tbl){   

    this.nativeStorage.setItem(tbl, { //'tblproyectos'
      tbl: info
    })
    .then(
      () => {       
       //this.tblproyectos=info;  //informacion actualizada.... 
      // return info;     
      },
      error =>{
       //this.tblproyectos=[];
      // return info
       console.log("se preentoun error.");
         }
    );

 


}

 gettabla(info,tbl):any[]{

  console.log(info);

  if(info.length>0){

    localStorage.setItem(tbl, JSON.stringify(info));
    //this.tblproyectos=info;
    return info;
  }
  else{

    var guardado = localStorage.getItem(tbl); 

    console.log("error 4");
    //  console.log(guardado [tbl]);
    if(guardado!=null){

      console.log("verificando guardado...");
      //console.log(guardado.length);

      console.log(guardado);
     return JSON.parse(guardado);
      //this.tblproyectos=JSON.parse(guardado)

    }
    else{
      return [];
     // this.tblproyectos=[];
    }

    //console.log( this.tblproyectos);

  }  

}

 gettablasync(info,tbl):any[]{

    localStorage.setItem(tbl, JSON.stringify(info));
    //this.tblproyectos=info;
    return info;
  
}

/////////////////////////////////////////////////////////


  async sincronizar(){

    console.log("iniciando sincronizacion...");    
    
   // localStorage.setItem('tblproyectos', JSON.stringify([]));
   // localStorage.setItem('tblusuarios', JSON.stringify([]));
   // localStorage.setItem('tblfaseproy', JSON.stringify([]));
   // localStorage.setItem('tblproyusu', JSON.stringify([]));
      
this.startloading();
   
///////////////////////////////////////////////////


(await this.getapi(1)).subscribe(info => {  

  //////////////////////////////s
  console.log("Tabla-Proyectos");
  console.log(info);
  

for(var i=0;i<info.length;i++){
info[i]['descripcion']=info[i]['info']['info']['descripcion'];  
}

  if(this.plataforma()[0].desktop ==0) {
   // this.gettablaproyectosapp(info);
    this.tblproyectos= this.gettablaapp(info,'tblproyectos');
    }else{   
    this.tblproyectos= this.gettabla(info,'tblproyectos');         
   // this.gettablaproyectos(info);  
    }
   
  //////////////////////////////
 
}, (error) => {

 console.log(error);

 console.log("primmer error...");
 //////////////////////////////

 if(this.plataforma()[0].desktop ==0) {

   //this.gettablaproyectosapp([]);
   this.tblproyectos= this.gettablaapp([],'tblproyectos');

   }else{   

    this.tblproyectos= this.gettabla([],'tblproyectos'); 
   //this.gettablaproyectos([]);
   }

   console.log("complete fase proyectos...");
  
  this.fases++;

  if(this.fases==3)
  this.ultfase()

 //////////////////////////////

},()=>{   
  
  console.log("complete fase proyectos...");
  
  this.fases++;

  if(this.fases==3)
  this.ultfase()
 
} );

(await this.getapi(3)).subscribe(info => {  

  //////////////////////////////
  console.log("Tabla-Proyusu");
  console.log(info);

  if(this.plataforma()[0].desktop ==0) {

  this.tblproyusu= this.gettablaapp(info,'tblproyusu');
  }else{   
  this.tblproyusu= this.gettabla(info,'tblproyusu');
  }

  //////////////////////////////
 
}, (error) => {

 console.log(error);

 //////////////////////////////

 if(this.plataforma()[0].desktop ==0) {
   this.tblproyusu= this.gettablaapp([],'tblproyusu');
   }else{      
    this.tblproyusu= this.gettabla([],'tblproyusu');
   }

   console.log("complete fase proyectos...");
  
  this.fases++;

  if(this.fases==3)
  this.ultfase()

 //////////////////////////////

},()=>{ this.fases++;
 
  if(this.fases==3)
  this.ultfase()

} );

(await this.getapi(4)).subscribe(info => {  

  //////////////////////////////
  console.log("Tabla-Faseproy");
  console.log(info);

  
for(var i=0;i<info.length;i++){
  info[i]['descripcion']=info[i]['info']['info']['descripcion'];  
  info[i]['aux']=info[i]['info']['info']['descripcion'];  
  }
  

  if(this.plataforma()[0].desktop ==0) {
    //this.gettablafaseproyapp(info);
    this.tblfaseproy= this.gettablaapp(info,'tblfaseproy');
    }else{      
    //this.gettablafaseproy(info);
    this.tblfaseproy= this.gettabla(info,'tblfaseproy');
    }    
  //////////////////////////////
 
}, (error) => {

 console.log(error);
 this.closedloading();

 //////////////////////////////

 if(this.plataforma()[0].desktop ==0) {

   //this.gettablafaseproyapp([]);
   this.tblfaseproy= this.gettablaapp([],'tblfaseproy');
   }else{      
   //this.gettablafaseproy([]);
   this.tblfaseproy= this.gettabla([],'tblfaseproy');
   }

   console.log("complete fase proyectos...");
  
  this.fases++;

  if(this.fases==3)
  this.ultfase()

 //////////////////////////////
 
},()=>{

  this.fases++;
  if(this.fases==3)
  this.ultfase()
  
} );


(await this.getapi(5)).subscribe(info => {  

  //////////////////////////////
  console.log("Tabla-Empresas");
  console.log(info);

  
for(var i=0;i<info.length;i++){
  info[i]['descripcion']=info[i]['info']['info']['descripcion'];  
  info[i]['aux']=info[i]['info']['info']['descripcion'];  
  }
  

  info.sort((a, b) => {
  let fa = a.descripcion.toLowerCase(),
      fb = b.descripcion.toLowerCase();

  if (fa < fb) {
      return -1;
  }
  if (fa > fb) {
      return 1;
  }
  return 0;
});

  if(this.plataforma()[0].desktop ==0) {
    //this.gettablaempresasapp(info);
    this.tblempresas= this.gettablaapp(info,'tblempresas');
    }else{      
    //this.gettablaempresas(info);
    this.tblempresas= this.gettabla(info,'tblempresas');
    }

  //////////////////////////////
 
}, (error) => {

 console.log(error);
 this.closedloading();

 //////////////////////////////

 if(this.plataforma()[0].desktop ==0) {

   //this.gettablaempresasapp([]);
   this.tblempresas= this.gettablaapp([],'tblempresas');

   }else{      
   //this.gettablaempresas([]);
   this.tblempresas= this.gettablaapp([],'tblempresas');
   }

   console.log('sali...');
 //////////////////////////////
 
},()=>{

    
} );

console.log('sali...');


 
}

plataforma(){
  
    //console.log(this.platform.platforms());
    //var res=[];
    var resand  = this.platform.platforms().filter(word => word.includes("android")); 
    var resdes  = this.platform.platforms().filter(word => word.includes("desktop")); 
  
   // console.log(resdes);
  
    return [{android:resand.length,desktop:resdes.length}]
  
  
  }


proyectos(){

  /*
 var fecha={
  fecha:fecha,
  entrada:"",
  salida:"",
  tiempos:[],
  avances:[],
  retrasos:[],
  estado:0,
  transmitido:0
  
  }*/

  //7.0628913,-73.8498502
  this.info.proyecto.push({id:1,descripcion:"desc1",feha:"2021-08-10",lat:7.0628913,lon:-73.8498502,estado:0,trabajos:[],hextras:[],fechas:[]});
 // this.info.proyecto.push({id:2,descripcion:"desc1",feha:"2021-08-11",estado:0,trabajos:[],hextras:[],fechas:[]});
  //this.info.proyecto.push({id:3,descripcion:"desc1",feha:"2021-08-12",estado:0,trabajos:[],hextras:[],fechas:[]});
}


/*


*/


async crear(){

  await this.proyectos();

  this.nativeStorage.setItem('myitem',this.info)
  .then(
    () => {console.log('Stored item!')
  this.datainfo=this.info
  }
    ,
    error => console.error('Error storing item', error)
  );

}

inicializar(){

  this.nativeStorage.getItem('myitem')
  .then(
    data => {        
      console.log(data);     
      this.datainfo=data;   
     // console.log(JSON.stringify(data["property"]));     
    },
    error => {
      console.error(error);
       this.crear();
    }
  );


}


crearfecha(){


 var fecha={
  fecha:new Date().getTime(),
  entrada:"12:10",
  salida:"",
  tiempos:[],
  avances:[],
  retrasos:[],
  estado:0,
  transmitido:0
  
  }

  this.info.proyecto[0]["fechas"].push(fecha);
  
}

getdatainfo(){

  console.log(JSON.stringify(this.datainfo));  

return  this.datainfo;   
}


distancia(lat1,lat2,lon1,lon2){

 
  
 
  var dlat=(lat2-lat1)*Math.PI/180;
  var dlon=(lon2-lon1)*Math.PI/180; 

  var a= Math.sin(dlat/2)*Math.sin(dlat/2) + Math.cos(lat1*Math.PI/180)* Math.cos(lat2*Math.PI/180)*Math.sin(dlon/2)*Math.sin(dlon/2);
  var c= 2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));

  var d=6378.1*c*1000;

  return Math.ceil(d);
  //console.log("distancia : "+ Math.ceil(d));
  //console.log("dlat : "+ dlat);


}

async getGeolocation(){
 
  //this.lat=0;
  //this.lon=0;
  
   const coordinates = await Geolocation.getCurrentPosition();
  
    console.log('Current position:', coordinates.coords.latitude);
    console.log('Current position:', coordinates.coords.longitude);

    //this.lat=coordinates.coords.latitude
    //this.lon=coordinates.coords.longitude   

    return coordinates

}

async startloadingetxt(texto) {

  
  this.loading = await this.loadingController.create({
    cssClass: 'custom-loader-class',
    spinner:'dots',
    message: texto
    
  });

     
  await this.loading.present();
  //const { role, data } = await loading.onDidDismiss();
  //console.log('Loading dismissed with role:', role);

}

async startloading() {

  
  this.loading = await this.loadingController.create({
    cssClass: 'custom-loader-class',
    spinner:'dots',
    message: 'Cargando'
    
  });
  
  await this.loading.present();
  //const { role, data } = await loading.onDidDismiss();
  //console.log('Loading dismissed with role:', role);

}


  async referencia(){

  if(this.loading!=null){
    //console.log("resolvi el error...");
    await this.loading.dismiss();
    clearInterval(this.myInterval);
     }   

     //console.log("interval");
     //console.log(this.loading);

}

async closedloading(){

  console.log(this.loading);

  if(this.loading!=null){
 await this.loading.dismiss();
  }else
  {
  
 var ref=this.loading;

 this.myInterval= setInterval(async ()=> {

    this.referencia();
    
  }, 1500);

    
    console.log("existe un error...");
  }


}


verificarerror(){

// funcion que permite verificar elerror de conexion ... 
// o un error de la app.


}


jsondatavector(data){

  var info="";  
  console.log(data);   
  
  var aux=Object.entries(data);  
  console.log(aux);  
  
  for(var i=0;i<aux.length;i++){

    var auxint=Object.entries(aux[i][1]);   
    
    console.log("xxxx");
    console.log( auxint);

    if(info.length>0){info+="},{";}

    if(auxint.length>0){
    for(var j=0;j<auxint.length;j++){
  
      if(j>0){info+=",";} 


  console.log(auxint[j][0]);
  console.log( auxint[j][1]);


  if(typeof auxint[j][1] === 'string')
  info+='\"'+auxint[j][0]+'\":\"'+auxint[j][1]+'\"';
  else{
    if(typeof auxint[j][1] === 'object'){       
  
    ///////////////////////////////////////////

    var vdata =auxint[j][1];

    //var inf2=Object(vdata).length
 
   if(Object(vdata).length==0){
 
     var resp='\"'+auxint[j][0]+'\":'+'[]';
 
   }
   else{

    ///////////////////////////////////////////
      var resp='\"'+auxint[j][0]+'\":'+'[{'+this.jsondatavector(auxint[j][1])+'\}]';
      }  
      
      console.log(resp);
      info+=resp;



    }else{

  info+='\"'+auxint[j][0]+'\":'+auxint[j][1];}
  }
  
    }
    }else{
      if(typeof aux[i][1] === 'string')
      info+='\"'+aux[i][0]+'\":\"'+aux[i][1]+'\"';
    }


 }
  
    return info;
  
    }


jsondata(data){

  var info="";
  
  
  console.log(data);
  
  
  
  var aux=Object.entries(data);
  
  console.log(aux);
  
  
  for(var i=0;i<aux.length;i++){
  
  if(i>0){info+=",";}
  if(typeof aux[i][1] === 'string')
  info+='\"'+aux[i][0]+'\":\"'+aux[i][1]+'\"';
  else{
    if(typeof aux[i][1] === 'object'){

      //console.log( aux[i][1].toString())

      aux[i][1]=String(aux[i][1].toString()).replace(",", "\",\"");
      console.log(aux[i][1]);
      info+='\"'+aux[i][0]+'\":[\"'+aux[i][1]+'\"]';
    }else{
  info+='\"'+aux[i][0]+'\":'+aux[i][1];}
  }
  
  }
    
  
    return info;
  
    }


//////////////////////////////////////////

jsondatav2(data){

  var info="";
  
  
  console.log(data);
  
  
  
  var aux=Object.entries(data);
  
  console.log(aux);
  
  
  for(var i=0;i<aux.length;i++){
  
  if(i>0){info+=",";}
  if(typeof aux[i][1] === 'string')
  info+='\"'+aux[i][0]+'\":\"'+aux[i][1]+'\"';
  else{
    if(typeof aux[i][1] === 'object'){

      //console.log( aux[i][1].toString())

     /// aux[i][1]=String(aux[i][1].toString()).replace(",", "\",\"");
    //  console.log(aux[i][1]);
    //  info+='\"'+aux[i][0]+'\":[\"'+aux[i][1]+'\"]';
    var vdata =aux[i][1];

   //var inf2=Object(vdata).length

  if(Object(vdata).length==0){

    var resp='\"'+aux[i][0]+'\":'+'[]';

  }
  else{
    var resp='\"'+aux[i][0]+'\":'+'[{'+this.jsondatavector(aux[i][1])+'\}]';
  }
    console.log(resp);
    info+=resp;

    }else{
  info+='\"'+aux[i][0]+'\":'+aux[i][1];}
  }
  
  }
    
  
    return info;
  
    }







async getapi(x){

  //console.log("service idcod: "+x);
 //https://cootraman.com/ventas2/sql.php
 //https://dydwebstore.com/conexion/sqljson.php


return this.http.post<any[]>('https://negociosinmobiliariosryr.com/mantenimiento/docionic/sql.php', {idcod:x});  


//return infosalida;
 
}

getapibus(x,y){ 
 
  return this.http.post<any[]>('https://negociosinmobiliariosryr.com/mantenimiento/docionic/sql.php', {idcod:x,bus:y});  
    
}

postapi(data:any){
    
  return this.http.post<any[]>('https://negociosinmobiliariosryr.com/mantenimiento/docionic/sqljson.php', data);

}


_keyUp(e: any) {

  let input;
  if (e.metaKey || e.ctrlKey) {
    return true;
  }
  if (e.which === 32) {
   return false;
  }
  if (e.which === 0) {
   return true;
  }
  if (e.which < 33) {
    return true;
  }
  input = String.fromCharCode(e.which);
  return !!/[\d\s]/.test(input);


}


_keyUppor(e: any) {


  console.log(e.target.value.length);

  
  let arr = e.target.value.split('.');  // Convert string to array of characters
  
 if(arr.length>1){
  if (e.which === 46) {
  return false;}
 }

 if(e.which >=48 && e.which <=57){

  if(e.target.value+e.key>=100){
    return false;
  }

 }

  if(e.target.value.length==5)
  return false;

  let input;
  if (e.metaKey || e.ctrlKey) {
    return true;
  }
  if (e.which === 46) {

     return true;
   }

  if (e.which === 32) {
   return false;
  }
  if (e.which === 0) {
   return true;
  }
  if (e.which < 33) {
    return true;
  }
  input = String.fromCharCode(e.which);
  return !!/[\d\s]/.test(input);


}


crenumeral(e:any ){

var dato= numeral(String(e).replace(/[^0-9\.,]/g, '')).format('$ 0,0');

//console.log(dato);

 return dato;
}

crenumeralsin(e:any ){

  var dato= numeral(String(e).replace(/[^0-9\.,]/g, '')).format(' 0,0');
  
  console.log(dato);
  
   return dato;
  }


  
crenumeralpor(e:any ){




 // var dato= numeral(String(e).replace(/[^0-9\.,]/g, '')).format(`00.00%`);
  
 //var dato= numeral(String(e).replace(/[^0-9\.]/g, '')).format(' 0,0');

  //console.log(dato);
  
   return e;
  }


  async dolar(){

  var res= await   fetch('https://api.exchangerate-api.com/v4/latest/USD')
  .then(response => response.json())
  .then(data => {

    return data.rates.COP;
   // console.log('Valor del Dólar en COP: ', data.rates.COP);
  })
  .catch(error => {return (-1)});

  return res;
}

// https://hermes.invias.gov.co/arcgis/rest/services/N767/consulta767/MapServer/0/query?where=1%3D1+and+Estado%3D%270%27+and+tipo+in%28%271%27%2C%272%27%2C%273%27%2C%274%27%2C%275%27%2C%2711%27%2C%2712%27%29&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&f=html


async getincientes(){

  const opciones = {method: 'GET'};  
    
  var res= await fetch('https://hermes.invias.gov.co/arcgis/rest/services/N767/consulta767/MapServer/0/query?where=1%3D1+and+Estado%3D%270%27+and+tipo+in%28%271%27%2C%272%27%2C%273%27%2C%274%27%2C%275%27%2C%2711%27%2C%2712%27%2C%2713%27%2C%2715%27%29&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&f=pjson', opciones)
  .then(response => response.json())
  .then(data => {
    console.log('Respuesta del servidor:', data);
    return data;
  })
  .catch(error => {
    console.error('Error:', error);
    return error;
  });
  
  return res;
  
    
  
  
  }

async getpeajes(){

const opciones = {method: 'GET'};  
  
var res= await fetch('https://hermes.invias.gov.co/arcgis/rest/services/N767/consulta767/MapServer/4/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&f=pjson', opciones)
.then(response => response.json())
.then(data => {
  console.log('Respuesta del servidor:', data);
  return data;
})
.catch(error => {
  console.error('Error:', error);
  return error;
});

return res;

  


}

async getpcargas(){

  const opciones = {method: 'GET'};  
    
  var res= await fetch('https://hermes.invias.gov.co/arcgis/rest/services/N767/consulta767/MapServer/0/query?where=1%3D1+and+Estado%3D%270%27+and+tipo%3D%277%27&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&f=pjson', opciones)
  .then(response => response.json())
  .then(data => {
    console.log('Respuesta del servidor:', data);
    return data;
  })
  .catch(error => {
    console.error('Error:', error);
    return error;
  });
  
  return res;
  
    
  
  
  }

  async postapi2eli(data:any){


    const opciones = {
      method: 'POST',    
      body: data
    };    
    
  var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/eliminar.php', opciones)
  .then(response => response.json())
  .then(data => {
    console.log('Respuesta del servidor:', data);
    return data;
  })
  .catch(error => {
    console.error('Error:', error);
    return error;
  });
  
  return res;
  
  
  
  }

  async postapi2up(data:any){


    const opciones = {
      method: 'POST',    
      body: data
    };    
    
  var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/upload.php', opciones)
  .then(response => response.json())
  .then(data => {
    console.log('Respuesta del servidor:', data);
    return data;
  })
  .catch(error => {
    console.error('Error:', error);
    return error;
  });
  
  return res;
  
  
  
  }

async postapi2doc(data:any){


  const opciones = {
    method: 'POST',    
    body: data
  };

  
  
var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/config.php', opciones)
.then(response => response.json())
.then(data => {
  console.log('Respuesta del servidor:', data);
  return data;
})
.catch(error => {
  console.error('Error:', error);
  return error;
});

return res;



}



async postapi2car(data:any){


  const opciones = {
    method: 'POST',    
    body: data
  };

  
  
var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/carpeta.php', opciones)
.then(response => response.json())
.then(data => {
  console.log('Respuesta del servidor:', data);
  return data;
})
.catch(error => {
  console.error('Error:', error);
  return error;
});

return res;



}


async postapitollguru(data:any){

  fetch('https://apis.tollguru.com/toll/v2/origin-destination-waypoints', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    "x-api-key": "24MJhqNJ8r4Tbj2tPqBpNhF2m9jrdmq2"
  },
  body:"{\r\n  \"from\": {\r\n    \"address\": \"bogota, colombia\"\r\n  },\r\n  \"to\": {\r\n    \"address\": \"zaragoga antioquia, colombia\"\r\n  },\r\n  \"vehicleType\": \"6AxlesTruck\"\r\n\r\n  "
  ,redirect: 'follow'  // This will automatically follow redirects
})
.then(response => response.json())
.then(data => console.log(data))
.catch(error => console.error('Error:', error));  
  
  return data;





}



  async postapi2(data:any){

  const opciones = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };
  
var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/sql.php', opciones)
.then(response => response.json())
.then(data => {
  console.log('Respuesta del servidor:', data);
  return data;
})
.catch(error => {
  console.error('Error:', error);
  return error;
});

return res;



}



async postbusapi2(data:any){

  const opciones = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };
  
var res= await fetch('https://oilandgas.com.co/appdocumentos/docionic/sql.php', opciones)
.then(response => response.json())
.then(data => {
  console.log('Respuesta del servidor:', data);
  return data;
})
.catch(error => {
  console.error('Error:', error);
  return error;
});

return res;



}


}